import React from "react";

import Event from "../event";
import { t } from "../../../helpers/translator";

var traps = {
    1: require("../../../images/greyhound-traps/1.png"),
    2: require("../../../images/greyhound-traps/2.png"),
    3: require("../../../images/greyhound-traps/3.png"),
    4: require("../../../images/greyhound-traps/4.png"),
    5: require("../../../images/greyhound-traps/5.png"),
    6: require("../../../images/greyhound-traps/6.png"),
};

export default function horseRacingEventTemplate () {
    let {event: data, gameInfo, market, hasPicture } = this.props;
    let isFavouriteType = (data.type === "Favourite") || (data.type === "2nd Favourite");

    let MarketEvent = null

    switch (market) {
        case 'winner':
            MarketEvent = (
                <>
                    <li className="horse-c-w price">
                        {data.nonrunner === 1 ? t("Non Runner") : data.price ? <Event sportType='HORSE' hoursType='PRICE' event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? null : data.sp_enabled ? <Event sportType='HORSE' hoursType='SP' name="SP" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                </>
            )
            break;
        case 'forecast':
            if (isFavouriteType) MarketEvent = null

            MarketEvent = (
                <>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? t("Non Runner") : data.sp_enabled ? <Event sportType='HORSE' hoursType='forecast$1' name="1st" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? null : data.sp_enabled ? <Event sportType='HORSE' hoursType='forecast$2' name="2nd" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? null : data.sp_enabled ? <Event sportType='HORSE' hoursType='forecast$1_2' name="1st or 2nd" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                </>
            )
            break;
        case 'tricast':
            if (isFavouriteType) MarketEvent = null

            MarketEvent = (
                <>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? t("Non Runner") : data.sp_enabled ? <Event sportType='HORSE' hoursType='tricast$1' name="1st" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? null : data.sp_enabled ? <Event sportType='HORSE' hoursType='tricast$2' name="2nd" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? null : data.sp_enabled ? <Event sportType='HORSE' hoursType='tricast$3' name="3rd" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                    <li className="horse-c-w">
                        {data.nonrunner === 1 ? null : data.sp_enabled ? <Event sportType='HORSE' hoursType='tricast$1_2_3' name="1st or 2nd or 3rd" event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                </>
            )
            break;
        default:
            MarketEvent = (
                <>
                    <li className="horse-c-w price">
                        {data.nonrunner === 1 ? t("Non Runner") : data.price ? <Event sportType='HORSE' hoursType='PRICE' event={data} price={data.price} game={gameInfo} market={{}} /> : null}
                    </li>
                </>
            )
    }

    if (data && gameInfo) {
        return <ul className='grayhounds-event'>
            <li className={`${!hasPicture ? 'without-picture' : ''}`}>
                <div className="h-color-v">
                    <img src={traps[data.original_order]}/>
                </div>
            </li>
            <li className="g-color-v">
                <p>{data.name}</p>
            </li>
            <li></li>
            <li></li>
            { MarketEvent }
        </ul>;
    }
    return <div>No Date</div>;
}